import api from './axiosInstance'


export default {
    getLoadProfiles() {
        return api.get('loadProfiles');
    },
    getLoadProfile(id) {
        return api.get(`loadProfiles/${id}`);
    },
    addLoadProfile(data) {
        const payload = new FormData();
        Object.keys().forEach(k => payload.append(k, data[k]));
        return api.post('loadProfiles', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    },
    updateLoadProfile(id, payload) {
        return api.patch(`loadProfiles/${id}`, payload);
    },
    deleteLoadProfile(id) {
        return api.delete(`loadProfiles/${id}`);
    },
    doPublish(id, isPublished) {
        return api.patch(`loadProfiles/${id}`, { isPublished });
    },
}